import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-667c60c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 실제 판매 예정 내역 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 실제 판매 [가격, 금액]은")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 판매 희망 [가격, 금액]과 다를 수 있습니다.")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 상세 설명 보기 > ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 주당 가격 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 판매 금액 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" (원단위 절사) ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 수량 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 약 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 주 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_box = _resolveComponent("ag-box")!

  return (_openBlock(), _createBlock(_component_ag_box, { "text-align": "center" }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box, {
        dp: "flex",
        "justify-content": "center",
        "margin-top": "10px",
        "margin-bottom": "8px",
        "align-items": "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text, {
            "margin-right": "8px",
            typography: "tit22b",
            color: "black"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ag_img, {
            width: "20px",
            src: "/assets/icon/help-circle@3x.png",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'실제 판매 예정 내역', 'clickContent':`실제 판매 예정 내역 툴팁`});_ctx.openPopover()}, ["stop"]))
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_text, {
        typography: "'main14r'",
        dp: "block",
        "text-align": "center",
        "margin-bottom": "8px",
        color: "gray3",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'실제 판매 예정 내역', 'clickContent':`상세 설명 보기`});_ctx.openPopover()}, ["stop"]))
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_ag_box, {
        "text-align": "left",
        "margin-top": "24px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text, {
            typography: "'main14r'",
            dp: "block",
            color: "gray3"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, {
            style: {"font-size":"24px","font-weight":"900","line-height":"50px"},
            color: "black"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedPriceRef)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, { style: {"font-size":"24px","line-height":"50px"} }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_box, {
        "text-align": "left",
        "margin-top": "24px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text, {
            typography: "'main14r'",
            dp: "block",
            color: "gray3"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, {
            style: {"font-size":"24px","font-weight":"900","line-height":"50px"},
            color: _ctx.belowMinPrice ? 'danger' : 'black'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedTotalPriceRef)), 1)
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_ag_text, {
            style: {"font-size":"24px","line-height":"50px"},
            color: _ctx.belowMinPrice ? 'danger' : 'black'
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_ag_text, {
            typography: "'main14r'",
            color: "gray3"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_ag_text, {
        typography: "main14r",
        color: "danger",
        dp: "block",
        "text-align": "left"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString('10,000원 이상이어야 합니다. 조건을 수정해주세요!'), 1)
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.belowMinPrice]
      ]),
      _createVNode(_component_ag_box, {
        "text-align": "left",
        "margin-top": "24px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text, {
            typography: "'main14r'",
            dp: "block",
            color: "gray3"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, { style: {"font-size":"24px","line-height":"50px"} }, {
            default: _withCtx(() => [
              _hoisted_13,
              _createVNode(_component_ag_text, {
                style: {"font-size":"24px","font-weight":"900","line-height":"50px"},
                color: "black"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedQtyRef)), 1)
                ]),
                _: 1
              }),
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, {
            typography: "'main14r'",
            color: "gray3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" (" + _toDisplayString(_ctx.$filters.currency(_ctx.expectedAssetRef)) + " 좌) ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}